/**
 * 应用主组件
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { HomePage } from './pages/Home';
import { GameDetailPage } from './pages/GameDetail';
import { SearchPage } from './pages/Search';
import { GamesPage } from './pages/Games';
import { ProfilePage } from './pages/Profile';
import { useTheme } from './hooks';
import { SettingsProvider } from './contexts/settings-context';
import './styles/main.css';

// 主应用组件
const App: React.FC = () => {
  // 初始化全局主题
  useTheme();

  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/game/:id" element={<GameDetailPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="*" element={
            <div className="not-found" style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center',
              minHeight: '100vh',
              color: 'var(--text-primary)',
              background: 'var(--bg-color)'
            }}>
              <h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>404</h1>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>页面未找到</p>
              <Link to="/" style={{ 
                color: 'var(--primary-color)',
                textDecoration: 'underline'
              }}>返回首页</Link>
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </SettingsProvider>
  );
};

export default App;
